import Container from '@/components/@base/container';
import whiteLogo from '@/assets/logos/user-can-select-assets-light.svg';
import darkLogo from '@/assets/logos/user-can-select-assets-dark.svg';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { SIZE_ENUM } from '@/components/@base/@types';
import useCommonModalStore from '@/store/common-modal-store';

const UserCanSelectAssets = ({handleGoToPayment}:{handleGoToPayment:() => void}) => {
  const {setShow} = useCommonModalStore()

  const chooseSelect = () => {
    setShow(false)
    sessionStorage.setItem('isSelectedVoucherOrWallet', 'true')
  }
  const choosePayment = () => {
    chooseSelect()
    handleGoToPayment()
  }
  return <Container center className='flex-col'>
    <img src={whiteLogo} alt='cancel payment' className='dark:hidden my-4'/>
    <img src={darkLogo} alt='cancel payment' className='hidden dark:block my-4'/>
    <Text medium size={SIZE_ENUM.MD} className='text-grayLight-1000 dark:text-grayLight-0 mb-2'>{localization.youForgotten}</Text>
    <Text medium size={SIZE_ENUM.SM} className='text-grayLight-600 dark:text-[#CCCCD1] mb-8 text-center px-3'>
      {localization.forgottenText}
    </Text>

    <Container id='upg-choose-asset-selection' center className='w-full py-4 text-primary hover:bg-primary-300/10
     border-b border-t border-grayLight-100 dark:border-grayDark-700 cursor-pointer focus:ring-0' onClick={chooseSelect}>
      {localization.comeBackToChoose}
    </Container>
    <Container id='upg-continue-perchese-whithout-asset-selection' center className='w-full py-4 text-grayLight-1000 hover:bg-grayLight-1000/10 dark:text-white cursor-pointer' onClick={choosePayment}>
      {localization.continuePayment}
    </Container>
  </Container>
}

export default UserCanSelectAssets;